module.exports = __webpack_public_path__ + "img/icon-fastest-parking@3x.6282e344.png";